/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/appCardList.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_CREDIT_UNIONS } from "../graphql";
import { VApplication } from "../../../application";
import { BreadcrumbService } from "../../breadcrumbService";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetHolderGroupProps {
  offset?: number;
  size?: number;
  where?: any;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: any): Promise<any>;
}
const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.BreadcrumbService") as BreadcrumbService;
};

export class AppCardListService implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getAppCardListProps.bind(this),
    };
  }

  async getAppCardListProps(args: any) {
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_CREDIT_UNIONS,
    //       variables: {
    //         input: {
    //           skip: args?.offset ?? 0,
    //           limit: args?.size ?? 10,
    //           where: [
    //             {
    //               column: "group",
    //               op: "Equal",
    //               value: ["CREDIT_UNION"],
    //             },
    //             ...args?.where,
    //           ],
    //         },
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data?.getListOfOrg) {
    //       let _templateData = this.formatHolderGroup(
    //         res?.data?.getListOfOrg?.data
    //       );
    //       return {
    //         appCardList: _templateData,
    //         isEmpty: res?.data?.getListOfOrg?.data?.length <= 0,
    //         activePage: res?.data?.getListOfOrg?.currentPage,
    //         pageSize: res?.data?.getListOfOrg?.pageSize,
    //         totalCount: res?.data?.getListOfOrg?.totalCount,
    //         totalPages: res?.data?.getListOfOrg?.totalPages,
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   throw err;
    // }
    return {
      ...(config || {}),
    };
    // return { ...(config || {}) };
  }
}
